import { Typography } from 'antd'
import { Page } from '@/structure'
import { Stepper } from '../components'
const { Title } = Typography

const StepsPage = ({ title, step, tab, className = '', children }) => {
  return (
    <Page className={className} title={title}>
      <Stepper currentStep={step} currentTab={tab} />
      <Title>{title}</Title>
      <div className="steps-content">{children}</div>
    </Page>
  )
}

export default StepsPage
